import { render, staticRenderFns } from "./Benefit.vue?vue&type=template&id=67c4ef94&scoped=true&"
import script from "./Benefit.vue?vue&type=script&lang=js&"
export * from "./Benefit.vue?vue&type=script&lang=js&"
import style0 from "./Benefit.vue?vue&type=style&index=0&id=67c4ef94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c4ef94",
  null
  
)

export default component.exports